import script from "./compoundQuery.vue?vue&type=script&setup=true&lang=js"
export * from "./compoundQuery.vue?vue&type=script&setup=true&lang=js"

import "./compoundQuery.vue?vue&type=style&index=0&id=52199c3e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52199c3e"]])

export default __exports__